// Shared source of truth for terms of service version.
// Consumed by both the frontend (ES module import) and backend (CommonJS require).
// Bump this whenever the terms content changes to prompt all users to re-accept.
const CURRENT_TERMS_VERSION = '1.1';
const TERMS_LAST_UPDATED = 'February 2026';

module.exports = { CURRENT_TERMS_VERSION, TERMS_LAST_UPDATED };
